export const PaymentTypes = {
  check: 'Check',
  wireTransfer: 'Wire Transfer',
  cash: 'Cash',
  creditCard: 'Credit Card',
  eft: 'EFT'
}
